import { forwardRef } from 'react';
import { styled } from 'goober';
var thumbSize = 14;
var sliderSize = 2;
export var DateIntervalContainer = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        width: '100%',
        padding: '0px 30px',
    });
});
export var RangeSliderContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'relative',
        cursor: 'pointer',
        backgroundColor: theme.colors.neutral.w100,
        height: "".concat(sliderSize, "px"),
        marginBottom: '6px',
        '&::before': {
            content: '',
            cursor: 'inherit',
            position: 'absolute',
            top: '-80%',
            bottom: '-80%',
            left: 0,
            right: 0,
        },
    });
});
var RangeSliderTipCommon = styled('button')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        fontSize: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 'none',
        border: 'none',
        appearance: 'none',
        backgroundColor: 'transparent',
        transform: 'translateY(-25%)',
    });
});
export var RangeSliderTipLeft = styled(RangeSliderTipCommon)(function (_a) {
    var theme = _a.theme;
    return ({
        left: '-35px',
        width: '32px',
        height: '32px',
    });
});
export var RangeSliderTipRight = styled(RangeSliderTipCommon)(function (_a) {
    var theme = _a.theme;
    return ({
        right: '-35px',
        width: '32px',
        height: '32px',
    });
});
export var RangeSliderIndicator = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        cursor: 'grab',
        height: '100%',
        position: 'absolute',
        backgroundColor: theme.colors.primary.w500,
        '&::before': {
            content: '',
            cursor: 'inherit',
            position: 'absolute',
            top: '-80%',
            bottom: '-80%',
            left: 0,
            right: 0,
        },
    });
});
var RangeSliderIndicatorThumbCommon = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        width: "".concat(thumbSize, "px"),
        height: "".concat(thumbSize, "px"),
        cursor: 'ew-resize',
        borderRadius: '50%',
        position: 'absolute',
        backgroundColor: theme.colors.ui.dark,
        borderStyle: 'solid',
        borderWidth: '3px',
        borderColor: theme.colors.ui.white,
    });
});
export var RangeSliderIndicatorThumbStart = styled(RangeSliderIndicatorThumbCommon, forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        left: 0,
        transform: "translate(-50%, calc(-50% + ".concat(sliderSize / 2, "px))"),
    });
});
export var RangeIndicatorThumbEnd = styled(RangeSliderIndicatorThumbCommon, forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        right: 0,
        transform: "translate(50%, calc(-50% + ".concat(sliderSize / 2, "px))"),
    });
});
export var RangeIndicatorThumbTooltip = styled('div')(function (_a) {
    var theme = _a.theme, $thumbTop = _a.$thumbTop, $thumbRight = _a.$thumbRight;
    return ({
        position: 'fixed',
        bottom: "".concat(document.documentElement.clientHeight - $thumbTop, "px"),
        left: "".concat($thumbRight, "px"),
        padding: '5px 6px',
        borderRadius: '5px',
        backgroundColor: theme.colors.ui.white,
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: theme.borderColor,
        boxShadow: '0px 4px 16px ' + theme.boxShadow,
        transform: "translateX(calc(-50% - ".concat(thumbSize / 2, "px))"),
        '&::after': {
            content: '',
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            borderStyle: 'solid',
            borderWidth: '5px',
            borderColor: 'transparent',
            borderTopColor: theme.colors.ui.white,
        },
        h5: {
            margin: 0,
            fontWeight: 'bold',
            fontSize: '12px',
            color: theme.colors.ui.dark,
            whiteSpace: 'nowrap',
        },
    });
});
export var RangeIntervalsContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '2px',
        marginBottom: '2px',
    });
});
export var RangeInterval = styled('div')(function (_a) {
    var theme = _a.theme, _b = _a.$thicc, $thicc = _b === void 0 ? false : _b, _c = _a.$hidden, $hidden = _c === void 0 ? false : _c;
    return ({
        height: $thicc ? '8px' : '4px',
        width: '1px',
        borderLeftStyle: 'solid',
        borderLeftWidth: $thicc ? '2px' : '1px',
        borderLeftColor: $thicc ? theme.colors.ui.dark : theme.colors.neutral.w700,
        opacity: $hidden ? 0 : 1,
    });
});
export var YearButtonsContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        display: 'flex',
        justifyContent: 'space-around',
    });
});
export var YearButtonWrapper = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '2px',
    });
});
export var YearButton = styled('button')(function (_a) {
    var theme = _a.theme, $inRange = _a.$inRange;
    return ({
        minWidth: '40px',
        height: '20px',
        outline: 'none',
        textAlign: 'center',
        fontSize: '12px',
        fontWeight: $inRange ? 'bold' : 'normal',
        color: theme.colors.ui.dark,
        backgroundColor: theme.colors.ui.transparent,
        borderStyle: 'none',
    });
});
